<template>
  <div v-if="loading">
    <v-skeleton-loader type="article"> </v-skeleton-loader>
  </div>
  <div v-else>
    <v-app-bar color="primary" dark flat app>
      <router-link to="/dashboard">
        <v-img class="mx-2" src="@/assets/plataforma-limer-inverse.png" max-width="100" width="70px" contain></v-img>
      </router-link>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-container>
      <v-stepper v-model="step" class="elevation-0">
        <v-stepper-header class="elevation-0 stepper-header mb-3">
          <v-stepper-step step="1" :complete="step > 1">Informe os seus dados básicos</v-stepper-step>
          <v-stepper-step step="2" :complete="step > 2">Escolha o seu horário de atendimento</v-stepper-step>
          <v-stepper-step step="3" :complete="step > 3">Complete a criação da sua conta</v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <AgendamentoForm v-model="usuario" @next-step="nextStep" @previous-step="previousStep" />
          </v-stepper-content>

          <v-stepper-content step="2">
            <EscolherHorario
              v-model="usuario"
              @update-horario="usuario.idHorario = $event"
              @next-step="nextStep"
              @previous-step="previousStep"
              v-if="step === 2"
            />
          </v-stepper-content>

          <v-stepper-content step="3">
            <AutenticacaoForm
              :loading="loadingSave"
              v-if="step === 3"
              v-model="usuario"
              @save-funcionario="saveFuncionario"
              @previous-step="previousStep"
            />
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-container>
  </div>
</template>

<script>
import AgendamentoForm from '@/modules/AcessoRapido/AgendamentoForm'
import AutenticacaoForm from '@/modules/AcessoRapido/AutenticacaoForm'
import EscolherHorario from '@/modules/AcessoRapido/EscolherHorario'
import acessoRapidoService from '@/services/acessoRapido'
import authenticationService from '@/services/authentication'
import { extractOnlyNumbers, formatDate } from '@/utils/formatter'

export default {
  name: 'AcessoRapido',
  props: ['token'],
  data() {
    return {
      loading: false,
      step: 1,
      usuario: {
        nome: null,
        email: null,
        senha: null,
        confirmaSenha: null,
        cpf: null,
        dtNascimento: null,
        dtAdmissao: null,
        sexo: null,
        idFuncao: null,
        idSetor: null,
        empresa: null
      },
      loadingSave: false
    }
  },
  components: {
    AgendamentoForm,
    AutenticacaoForm,
    EscolherHorario
  },
  methods: {
    nextStep() {
      this.step += 1
    },
    previousStep() {
      this.step -= 1
    },
    async saveFuncionario() {
      try {
        this.loadingSave = true
        const { data } = await acessoRapidoService.saveFuncionario(this.setupFuncionario())
        authenticationService.setToken(data.token)
        this.$router.push({ name: 'agendamentos' })
      } catch ({ response }) {
        this.$showErrorMessage(response.data.message)
      } finally {
        this.loadingSave = false
      }
    },
    setupFuncionario() {
      return {
        idHorario: this.usuario.idHorario,
        exame: this.usuario.exame,
        cpf: extractOnlyNumbers(this.usuario.cpf),
        nome: this.usuario.nome,
        senha: this.usuario.senha,
        email: this.usuario.email,
        dtNascimento: formatDate(this.usuario.dtNascimento),
        dtAdmissao: formatDate(this.usuario.dtAdmissao),
        sexo: this.usuario.sexo,
        idEmpresa: this.usuario.unidade ? this.usuario.unidade : this.usuario.empresa.idEmpresa,
        idFuncao: this.usuario.idFuncao,
        idSetor: this.usuario.idSetor
      }
    }
  }
}
</script>

<style scoped>
.stepper-header {
  border-bottom: 2px solid #055dff;
}
</style>
